<template>
    <img @click="openMobileMenu" class="close-icon" src="@/assets/navbar/close.png" alt="Icon">

    <NavbarButtons :isOpen="isOpen" />

    <!-- Social Networks -->
    <nav class="icon-social-container-mobile">
        <!-- Play Store button -->
        <a href="https://play.google.com/store/apps/developer?id=Black+Paladins" target="_blank">
            <img class="icon__social" src="@/assets/navbar/play_store_icon.png" alt="Play Store">
        </a>

        <!-- Github button -->
        <a href="https://github.com/jerffesonj/" target="_blank">
            <img class="icon__social" src="@/assets/navbar/github_icon.png" alt="Github">
        </a>

        <!-- Linkedin button -->
        <a href="https://www.linkedin.com/in/jerffesonj/" target="_blank">
            <img class="icon__social" src="@/assets/navbar/linkedin_icon.png" alt="Linkedin">
        </a>

        <!-- Itch.io button -->
        <a href="https://jerffesonj.itch.io/" target="_blank">
            <img class="icon__social" src="@/assets/navbar/itch_icon.png" alt="itch.io">
        </a>
    </nav>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import NavbarButtons from '@/components/Navbar/NavbarButtons.vue';

const props = defineProps({
    isOpen: Boolean,
});

// Emissor de eventos
const emit = defineEmits(['update:isOpen']);

function openMobileMenu() {
    emit('update:isOpen', !props.isOpen);
    console.log(props.isOpen)
}
</script>

<style lang="scss" scoped>
@import '~/src/assets/css/NavbarStyle.scss';
</style>